

import ProfileData from '~/components/profile/mixins/ProfileData'

export default {

    mixins: [ProfileData],

    data() {
        return {
            isReady: false,
            company: {},
            destination: {},
            //internalVisit: false,
            page: {},
        }
    },

    head() {

        let headObj = this.$head()
            .setPage(this.page)
            .setCanonicalUrl(this.canonicalURL);

        if(this.company.isMasterProfile) {
            headObj.addLink({
                rel: 'stylesheet',
                href: this.$mix('/assets/css/profile/show-master.css')
            })
        }

        return headObj.get()

        //return this.getHead()
    },


    mounted() {

        this.$nextTick(function () {

            this.isReady = true

        })

    },

    destroyed() {

        this.$store.dispatch('profile/CLEAR_STORE')

    },

    methods: {

        getHead() {

            let head = {
                link: [
                    /*{ rel: 'stylesheet', href: this.$mix('/styles/bootstrap-slider.min.css') },*/
                    /*{ rel: 'stylesheet', href: this.$mix('/assets/css/profile/show.css') },*/
                ],

            }

            if(this.company.isMasterProfile) {
                head.link.push({ rel: 'stylesheet', href: this.$mix('/assets/css/profile/show-master.css') })
            }

            if(this.isType('hotel')) {
                //head.link.push({ rel: 'stylesheet', href: this.$mix('/assets/css/profile/show-hotel.css') })
            }

            if(this.isType('event')) {
               //head.link.push({ rel: 'stylesheet', href: this.$mix('/assets/css/profile/show-venue.css') })
            }

            return head

        },

    },

    computed: {

        canonicalURL() {
            return this.company.profileRoute
        },

    }

}

